import React, {PureComponent} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import template from '../../templates/ProjectScope/ProjectScope.rt';
import pageHeaderTemplate from '../../templates/ProjectScope/ProjectScopePageHeader.rt';
import {EditorFooter as pageFooterTemplate} from '../PageLayout';
import * as actions from '../../actions';
import {getFilteredFeatureGroups, selectSearchTerm, hasSubFor, doesFeatureGroupHaveFeaturesWithLayersOfType, hasFeaturesWithEnabledFor} from './ProjectScopeSelector';
import {getFilteredPendingFeatureGroups} from './NewFeatureGroup/NewFeatureGroupSelector';
import * as editorNames from '../../constants/editorNames';
import {fetchData, setMode} from './ProjectScopeActions';
import {postQtCategory} from "../../components/NewScope/newScopeActions";
import ProjectScopeSortableItems from './ProjectScopeSortableItems';
import {arrayMove} from "../../utilities/helpers";
import {FEATURE_GROUP_ALL_NAME} from "../../constants/newScopeConstants";
import {errorBox_Show} from "../../actions/A_Popups";
import {AccessRights} from '../../schemas/accessRightsModel';

function mapStateToProps(state, ownProps) {
  const featureGroups = getFilteredFeatureGroups(state);
  const pendingFeatureGroups = getFilteredPendingFeatureGroups(state);
  const term = selectSearchTerm(state);
  const hasKitchenSub = hasSubFor(state)('kitchen');
  const hasBathroomSub = hasSubFor(state)('bathroom');
  let filteredFeatureGroups = featureGroups;

  const AR = AccessRights.get(state);

  const {projectScope} = state;
  const {activeMode} = projectScope;

  if((hasKitchenSub || hasBathroomSub) && !(hasKitchenSub && hasBathroomSub)) {
    filteredFeatureGroups = featureGroups && featureGroups.filter(fg => {
      return (hasBathroomSub && doesFeatureGroupHaveFeaturesWithLayersOfType(fg, 'brv'))
        || (hasKitchenSub && doesFeatureGroupHaveFeaturesWithLayersOfType(fg, 'kv3'))
        || (hasKitchenSub && doesFeatureGroupHaveFeaturesWithLayersOfType(fg, 'kv4'));
    });
  }

  if(activeMode != 'All') {
    filteredFeatureGroups = filteredFeatureGroups.filter(fg => {
      return hasFeaturesWithEnabledFor(fg, activeMode.toLowerCase());
    });
  }

  return {
    featureGroups: (ownProps.newScope && pendingFeatureGroups && pendingFeatureGroups.length)
      ? [...pendingFeatureGroups, ...filteredFeatureGroups]
      : filteredFeatureGroups,
    pendingFeatureGroups,
    term,
    qtCategories: state.newScope.qtCategories,
    activeQtCategoryIndex: state.newScope.activeQtCategoryIndex,
    featureGroupsSearchValue: state.newScope.featureGroupsSearchValue,
    AR: AccessRights.get(state),
    activeMode,
    showMode: (hasKitchenSub && hasBathroomSub) || AR.isSiteAdmin(false)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchFabricator: () => dispatch(fetchData()),
    loadFeatureInclusionPresets: () => dispatch(actions.featureInclusion.loadPreset()),
    setSearchTerm: (term) => dispatch(actions.setSearchTerm(term)),
    onLoadEditor: () => dispatch(actions.loadEditor(editorNames.PROJECT_SCOPE_SETUP)),
    onUnloadEditor: () => dispatch(actions.unloadEditor()),
    postQtCategory: (qtCategory, update) => dispatch(postQtCategory(qtCategory, update)),
    errorBox_Show: config => dispatch(errorBox_Show(config)),
    setMode: mode => dispatch(setMode(mode))
  };
}

class projectScope extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      reorderedFeatureGroups: [],
      activeMode: 'All'
    };
  }

  getFeatureCreatorLink = (groupName) => {
    return `features?group=${encodeURIComponent(groupName)}`;
  }

  update = () => this.forceUpdate();

  componentWillMount() {
    this.props.onLoadEditor();
    this.props.loadFeatureInclusionPresets()
      .then(this.props.fetchFabricator(this.props.loaded));

    document.addEventListener("newFeatureGroupAdded", this.update);
  }

  componentWillUnmount() {
    this.props.setSearchTerm('');
    this.props.onUnloadEditor();
    document.removeEventListener("newFeatureGroupAdded", this.update);
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.activeQtCategoryIndex !== this.props.activeQtCategoryIndex)
      || (nextProps.featureGroups && !this.props.featureGroups)
      || (nextProps.featureGroups && this.props.featureGroups
        && nextProps.featureGroups.length && (nextProps.featureGroups.length !== this.props.featureGroups.length))
      || (nextProps.pendingFeatureGroups && nextProps.pendingFeatureGroups.length
        && (!this.props.pendingFeatureGroups || !this.props.pendingFeatureGroups.length))
      || (nextProps.featureGroupsSearchValue !== this.props.featureGroupsSearchValue)
      || (nextProps.qtCategories && nextProps.activeQtCategoryIndex
        && nextProps.qtCategories[nextProps.activeQtCategoryIndex]
        && (nextProps.qtCategories[nextProps.activeQtCategoryIndex].featureGroups.length
          !== this.state.reorderedFeatureGroups.length))
    ) {
      this.setReorderedFeatureGroups(nextProps)
    }
  }

  componentDidMount() {
    this.setReorderedFeatureGroups(this.props)
  }

  setReorderedFeatureGroups = (nextProps = this.props) => {
    this.setState({
      reorderedFeatureGroups: []
    }, () => {
      this.setState({
        reorderedFeatureGroups: this.getFeatureGroups(nextProps)
      })
    })
  };

  getFeatureGroups = (nextProps = this.props) => {
    if (!nextProps.newScope) {
      return nextProps.featureGroups || []
    }
    // console.log("filteredFeatureGroups - before", nextProps.featureGroups);
    let filteredFeatureGroups = [];
    const currentActiveCategory = nextProps.qtCategories[nextProps.activeQtCategoryIndex];
    if (nextProps.featureGroups && currentActiveCategory && currentActiveCategory.name !== FEATURE_GROUP_ALL_NAME) {
      currentActiveCategory.featureGroups
        .sort((a, b) => a.order !== b.order ? a.order < b.order ? -1 : 1 : 0) // sort by order
        .forEach((group) => {
        const existingGroup = nextProps.featureGroups.find(featureGroup => featureGroup.name === group.groupName);
        if (existingGroup) {
          filteredFeatureGroups.push(existingGroup)
        }
      });
    } else {
      filteredFeatureGroups = nextProps.featureGroups || []
    }
    // console.log("filteredFeatureGroups - after", filteredFeatureGroups);
    if (nextProps.featureGroupsSearchValue) {
      const searchValue = nextProps.featureGroupsSearchValue.toLowerCase();
      return filteredFeatureGroups.filter(featureGroup => {
        return featureGroup.name && featureGroup.name.toLowerCase().includes(searchValue)
      })
    }
    return filteredFeatureGroups
  };

  shouldCancelStart = (event) => {
    const excludedClassNames = ["pj-scope-eye-icon", "pj-scope-lir-title", "pj-scope-lir-description",
      "pj-scope-lir-enable-wrapper", "pj-scope-more-info-icon", "pj-scope-button-wrapper",
      "message-system-dismiss-button", "message-box-buttons", "pj-scope-lir-remove",
      "pj-scope-lir-icon-edit", "pj-scope-delete-icon", "pj-scope-new-icon-library", "pj-scope-new-icon-overlay"];
    if (excludedClassNames.some(className => {
      return event.target.classList.contains(className) || event.target.closest("."+className)
    })) {
      return true
    }
  };

  // onSortStart = ({node, index, collection, isKeySorting}, event) => {
  onSortStart = () => {
    window.draggingFeatureGroup = true;
  };

  onSortEnd = ({oldIndex, newIndex}, event) => {

    window.draggingFeatureGroup = false;

    const activeCategory = this.props.qtCategories[this.props.activeQtCategoryIndex];

    if (event.target.closest(".assign-sidebar-list__item")) { // dragged on the sidebar category
      const categoryIndex = +event.target.closest(".assign-sidebar-list__item").dataset.index;
      if (categoryIndex) { // index !== 0
        const currentFeatureGroup = this.state.reorderedFeatureGroups[oldIndex]; // {name: "Baseboard", features: [{…}, {…}, {…}], ...}
        const droppableCategory = this.props.qtCategories[categoryIndex]; // qtCategory
        if (droppableCategory.featureGroups.some(fGroup => fGroup.groupName === currentFeatureGroup.name)
          // && (droppableCategory.id !== activeCategory.id) // not the same category and featureGroup is missing
        ) {
          // featureGroup already exist
          this.props.errorBox_Show({
            title: 'Error',
            text: `Feature group ${currentFeatureGroup.name} already exists in the ${droppableCategory.name} category`,
            rightButtonText: 'OK',
            isRightButtonVisible: true
          });
        } else {
          const nextOrder = Math.max(...droppableCategory.featureGroups.map(fGroup => fGroup.order)) + 1;
          droppableCategory.featureGroups.push({
            groupName: currentFeatureGroup.name,
            order: nextOrder
          });
          this.props.postQtCategory(droppableCategory, true);
        }
      }
    } else if (this.props.activeQtCategoryIndex) { // sorting (if it is not All group)
      const filterGroups = this.getFeatureGroups(this.props);
      const reorderedFeatureGroups = arrayMove(filterGroups, oldIndex, newIndex);

      //1) update redux qtCategory & post in on the backend
      reorderedFeatureGroups.forEach((featureGroup, featureGroupIndex) => {
        const currentGroup = activeCategory.featureGroups.find(group => {
          return group.groupName && featureGroup.groupName && group.groupName.toLowerCase() === featureGroup.groupName.toLowerCase()
        });
        currentGroup.order = featureGroupIndex;
      });

      this.props.postQtCategory(activeCategory, true);

      //2) update redux qtCategory & post in on the backend
      this.setState({
        reorderedFeatureGroups: []
      }, () => {
        this.setState({
          reorderedFeatureGroups
        })
      });
    }
  };

  removeFeatureGroupFromCategory = (featureGroup) => {
    const activeCategory = this.props.qtCategories[this.props.activeQtCategoryIndex];
    const featureGroupIndex = activeCategory.featureGroups.findIndex(fGroup => fGroup.groupName === featureGroup.name);
    const deletedOrder = activeCategory.featureGroups.find(fGroup => fGroup.groupName === featureGroup.name).order;

    activeCategory.featureGroups.splice(featureGroupIndex, 1); // delete featureGroup
    activeCategory.featureGroups = activeCategory.featureGroups.map(fGroup => {
      if (fGroup.order > deletedOrder) {
        fGroup.order--; // set order equal to order - 1
      }
      return fGroup
    });
    this.props.postQtCategory(activeCategory, true); // update BE && Frontend
  };

  render() {
    return this.props.newScope
      ? ProjectScopeSortableItems.call(this, this.props.activeQtCategoryIndex, this.removeFeatureGroupFromCategory)
      : template.call(this)
  }
}

projectScope.propTypes = {
  fetchFabricator: PropTypes.func.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  onLoadEditor: PropTypes.func.isRequired,
  onUnloadEditor: PropTypes.func.isRequired,
  newScope: PropTypes.bool
};

const ProjectScope = projectScope;
const ProjectScopePageHeader = pageHeaderTemplate;
const ProjectScopePageFooter = pageFooterTemplate;

const connector = connect(mapStateToProps, mapDispatchToProps);
const ProjectScopeContainer = connector(ProjectScope);
const ProjectScopePageHeaderContainer = connector(ProjectScopePageHeader);
const ProjectScopePageFooterContainer = connector(ProjectScopePageFooter);

export {
  ProjectScope,
  ProjectScopeContainer,
  ProjectScopePageHeader,
  ProjectScopePageHeaderContainer,
  ProjectScopePageFooter,
  ProjectScopePageFooterContainer
};
